module.exports = __webpack_public_path__ + "img/gif7.20749d56.jpg";